import { Skeleton } from '../shared/ui/skeleton';

export const SessionSkeleton = () => (
  <div className="space-y-4">
    <Skeleton className="h-9 w-64" />
    <Skeleton className="h-64 w-full" />
  </div>
);

export const SessionShellSkeleton = () => (
  <div className="min-h-dvh bg-canvas font-sans text-content antialiased">
    <div className="hidden border-r border-line lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-60 lg:flex-col" />
    <div className="lg:pl-60">
      <main className="py-10">
        <div className="px-4 sm:px-6 lg:px-8">
          <SessionSkeleton />
        </div>
      </main>
    </div>
  </div>
);
